import React from "react";

export default function Marquee({ items }) {
  const doubled = [...items, ...items];
  return (
    <div className="scroll-strip overflow-hidden bg-plum-deep border-y border-gold/30 py-4" data-testid="editorial-ribbon">
      <div className="marquee-track font-serif-display text-cream text-lg italic">
        {doubled.map((t, i) => (
          <span key={i} className="whitespace-nowrap">
            {t}
            <span className="mx-6 text-gold">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
